import React from 'react';
import { useMFRRestrictionsListTableState } from './useMFRRestrictionsListTableState';
import TableTop from '../../../../core/table/TableTop';
import TableHead from '../../../../core/table/TableHead';
import { useMFRRestrictionsListStore } from '../pagehooks/useMFRRestrictionsListStore';
import TableBody from '../../../../core/table/TableBody';
import TablePaging from '../../../../core/table/TablePaging';
import SaveToExcelButton from '../../../../core/table/actions/SaveToExcelButton';
import { ngDelegate } from '../../../../core/services/ng.delegate';
import { HttpErrorIgnore } from '../../../../../global';
import { getExcel } from '../../data/mfrRestrictionsRepo';
import { AdminMFRRestrictionModel } from '../edit/mfr_edit_restrictions_types';
import { MFRRestrictionsDataItem } from '../mfr_restrictions_list_types';
import { ActionsFeature } from '../../../../core/table/table.types';
import TableList from '../../../../core/table/TableList';

export const payorListTableId = 'adminPayorList';
const FILE_NAME = 'Verity-ManufacturerRestrictionsList';

const onGetExcel = (): Promise<HttpErrorIgnore | undefined> => getExcel(FILE_NAME);

type MFRRestrictionsListTableProps = {
    selectedRows: Record<string, AdminMFRRestrictionModel>;
    actions: ActionsFeature[];
    rows: MFRRestrictionsDataItem[];
    onClick: (rows: MFRRestrictionsDataItem[]) => void;
};

const MFRRestrictionsListTable = ({
    selectedRows,
    actions,
    rows,
    onClick,
}: MFRRestrictionsListTableProps): JSX.Element => {
    const { canEdit } = useMFRRestrictionsListStore();
    const { waiting, fltStats, paging, cols, sections, sort, filters, setFilter, setSort, setPaging, setWait } =
        useMFRRestrictionsListTableState();

    if (waiting) {
        ngDelegate.wait(true, true);
        return <></>;
    } else {
        ngDelegate.wait(false, true);
    }

    return (
        <TableList>
            <TableTop
                id={payorListTableId}
                fltStats={fltStats}
                topRight={
                    <SaveToExcelButton
                        waiting={waiting}
                        setWait={setWait}
                        onGetExcel={onGetExcel}
                    />
                }
            />
            <table>
                <TableHead
                    cols={cols}
                    actions={canEdit ? actions : undefined}
                    sections={sections}
                    sort={sort}
                    filters={filters}
                    setFilter={setFilter}
                    setSort={setSort}
                />
                <TableBody
                    selectedRows={selectedRows}
                    actions={canEdit ? actions : undefined}
                    cols={cols}
                    rows={rows}
                    onClick={canEdit ? onClick : undefined}
                />
            </table>
            <TablePaging
                paging={paging}
                setPaging={setPaging}
                fltStats={fltStats}
            />
        </TableList>
    );
};

export default MFRRestrictionsListTable;
